var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ul",
        {
          staticClass: "accordion",
          attrs: {
            id: "addendum-accordion",
            "data-accordion": "",
            "data-deep-link": "true",
            "data-allow-all-closed": "true",
            "data-multi-expand": "true",
            "data-update-history": "true",
            "data-deep-link-smudge": "500",
          },
        },
        _vm._l(_vm.addendums, function (revision, index) {
          return _c(
            "li",
            {
              key: revision.commentUpdatedAt,
              staticClass: "accordion-item",
              class: { "is-active": index === 0 },
              staticStyle: { position: "relative" },
              attrs: { "data-accordion-item": "" },
            },
            [
              _c("div", { staticClass: "item__header" }, [
                _c("div", { staticClass: "header__title" }, [
                  _c("span", { staticClass: "title__left" }, [
                    _c("p", { staticClass: "title__text" }, [
                      _vm._v(
                        _vm._s(_vm.$t("summary.location.addendum")) +
                          " " +
                          _vm._s(revision.version)
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.isPicView
                      ? _c("i", {
                          staticClass:
                            "fa fa-pencil fa-lg icon accordion-title-edit-icon",
                          on: {
                            click: function ($event) {
                              return _vm.editComment(index)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showEditHistory(index)
                      ? _c("p", { staticClass: "edit-history" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.lastUpdatedContent(index)) +
                              "\n            "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    class: _vm.chevronStatus(index),
                    attrs: { href: "#addendum-accordion-" + index },
                    domProps: { innerHTML: _vm._s(_vm.chevronHtmlCode) },
                    on: {
                      click: function ($event) {
                        return _vm.toggleItem(index)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.commentsToDisplay[index] && !_vm.showEditArea(index)
                  ? _c("p", { class: _vm.commentStatus(index) }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.commentsToDisplay[index]) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showEditArea(index)
                  ? _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.commentsToDisplay[index],
                          expression: "commentsToDisplay[index]",
                        },
                      ],
                      ref: "edit-comment-area-" + index,
                      refInFor: true,
                      attrs: {
                        rows: "3",
                        placeholder: _vm.$t("summary.addendumComment"),
                      },
                      domProps: { value: _vm.commentsToDisplay[index] },
                      on: {
                        blur: _vm.saveComment,
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.commentsToDisplay,
                            index,
                            $event.target.value
                          )
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion-content",
                  attrs: {
                    id: "addendum-accordion-" + index,
                    "data-tab-content": "",
                  },
                },
                [
                  _c("AddendumItem", {
                    attrs: { addendums: revision.addendum },
                  }),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.isInAddendum ? _c("VendorBidStatusCollapse") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }